import React from "react";

import "./style.scss";
import { Headline, SemanticHeadlineSize, VisualHeadlineSize } from "app/layout/Headline/Headline";

export interface Props {
    children?: React.ReactNode;
    className?: string;
    sectionControls?: React.ReactNode;
    delimiter?: boolean;
    headline: string;
    headlineCount?: number;
    visualHeadlineSize?: VisualHeadlineSize;
    semanticHeadlineSize?: SemanticHeadlineSize;
}

function wrapLastWord(text: string) {
    const parts: React.ReactNode[] = text.split(" ").map(word => `${word} `);
    parts.push(<span key="last">{(parts.pop() as string).trim()}</span>);
    return parts;
}

/**
 * A standardized header that conforms to the t-online styling
 */
export const SectionHeader = ({
    children,
    className,
    sectionControls,
    delimiter = false,
    headline,
    headlineCount,
    visualHeadlineSize,
    semanticHeadlineSize
}: Props) => {
    const classNames = ["sectionHeader"];

    if (delimiter) {
        classNames.push("delimiter");
    }

    if (className) {
        classNames.push(className);
    }

    return (
        <header className={classNames.join(" ")}>
            <div>
                <Headline visualSize={visualHeadlineSize} semanticSize={semanticHeadlineSize}>
                    {wrapLastWord(headline)}
                    {headlineCount !== undefined && <small>({headlineCount})</small>}
                </Headline>
                {sectionControls && <div className="sectionControls">{sectionControls}</div>}
            </div>
            {children && <div className="content">{children}</div>}
        </header>
    );
};
